import { useState } from 'react';
import { QueryState } from '../components/page';
import { usePrescreeningQueries } from '../api/hooks';
import type { PrescreeningQueryStatus } from '../api/types';
import { control } from './practice-agents';
import {
  PRESCREENING_UNAVAILABLE,
  PrescreeningHeader,
  QUERY_STATUS_TEXT,
  QueriesTable,
  prescreeningLoadError,
} from './prescreening';

type StatusFilter = 'all' | PrescreeningQueryStatus;

const STATUS_FILTERS: StatusFilter[] = [
  'all',
  'designing',
  'awaiting_approval',
  'approved',
  'rejected',
];

export function PrescreeningQueriesPage() {
  const [status, setStatus] = useState<StatusFilter>('all');
  const queries = usePrescreeningQueries(status === 'all' ? {} : { status });

  return (
    <div>
      <PrescreeningHeader />
      <QueryState isLoading={queries.isLoading} error={prescreeningLoadError(queries.error)}>
        {queries.data === null ? (
          <p role="status" className="text-sm text-muted-foreground">
            {PRESCREENING_UNAVAILABLE}
          </p>
        ) : (
          <>
            <div className="mb-4 flex flex-wrap items-end gap-3 rounded-3xl border bg-card p-4">
              <label className="flex flex-col gap-1 text-xs text-muted-foreground">
                Status
                <select
                  aria-label="Status"
                  className={control}
                  value={status}
                  onChange={event => setStatus(event.target.value as StatusFilter)}
                >
                  {STATUS_FILTERS.map(value => (
                    <option key={value} value={value}>
                      {value === 'all' ? 'All statuses' : QUERY_STATUS_TEXT[value]}
                    </option>
                  ))}
                </select>
              </label>
              <p className="max-w-xl text-xs text-muted-foreground">
                Rudi&apos;s designer drafts each query from the trial&apos;s criteria and the
                Practice&apos;s structure report, runs the drafts on the practice computer, and
                waits for a super admin to approve one. The practice sees a shortlist only for an
                approved version.
              </p>
            </div>
            <QueriesTable
              queries={queries.data ?? []}
              empty={
                status === 'all'
                  ? 'No criteria queries yet. A study coordinator starts one with "Start matching" on a study in Clinical Trials.'
                  : 'No criteria queries have this status.'
              }
            />
          </>
        )}
      </QueryState>
    </div>
  );
}
